import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { CartProvider } from '../../context/CartContext';
// Using ModernHomePage for the redesigned landing page
import Homepage from '../HomePage/ModernHomePage'
// Using ModernServicePage as the unified "Our Services" page
import ServicePage from '../ServicePage/ModernServicePage';
// Using ModernAboutPage for the redesigned about page
import AboutUsPage from '../AboutUsPage/ModernAboutPage';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';

// Using ModernTermsPage for the redesigned terms page
import TermsPage from '../TermsPage/ModernTermsPage';
// Using ModernPrivacyPage for the redesigned privacy policy page
import PrivacyPage from '../PrivacyPage/ModernPrivacyPage';
// Using ModernContactPage for the redesigned contact page
import ContactPage from '../ContactPage/ModernContactPage';
// Using ModernWhatWeDo for the redesigned what we do page
import WhatWeDo from '../../components/what-we-do/ModernWhatWeDo';
// Using ModernWhoWeServe for the redesigned who we serve page
import WhoWeServe from '../../components/who-we-serve/ModernWhoWeServe';
// Using Modern Sector Pages
import Federal from '../../components/Sectors/ModernFederal';
import Department from '../../components/Sectors/ModernDepartment';
import Sled from '../../components/Sectors/ModernSled';
import Commercial from '../../components/Sectors/ModernCommercial';
import Health from '../../components/Sectors/ModernHealth';
// Using Modern What-We-Do Pages
import ItModernization from '../../components/what-we-do/pages/ModernItModernization';
import Workforce from '../../components/what-we-do/pages/ModernWorkforce';
import DigitalTransformation from '../../components/what-we-do/pages/ModernDigitalTransformation';
import Cybr from '../../components/what-we-do/pages/ModernCybersecurity';
import AiAutomation from '../../components/what-we-do/pages/ModernAiAutomation';
import ArmySolutions from '../../components/what-we-do/pages/ModernArmySolutions';
import AirForce from '../../components/what-we-do/pages/ModernAirForce';
import SpaceForce from '../../components/what-we-do/pages/ModernSpaceForce';
import NavySolutions from '../../components/what-we-do/pages/ModernNavySolutions';
import MarineCorps from '../../components/what-we-do/pages/ModernMarineCorps';
// Using Modern Partner Pages
import ViewPartners from '../PartnersPage/ModernViewPartners';
import ModernContractsPage from '../ContractsPage/ModernContractsPage';
import NasaSewpPage from '../ContractsPage/ModernNasaSewpPage';
// Using ModernAccessoriesCatalog for the redesigned accessories page
import AccessoriesCatalog from '../../components/product/ModernAccessoriesCatalog';
// Cart and Product pages
import CartPage from '../CartPage/CartPage';
import CheckoutPage from '../CheckoutPage/CheckoutPage';
import ProductPage from '../ProductPage/ProductPage';


const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="home" element={<Homepage />} />
          <Route path="about" element={<AboutUsPage />} />
          {/* Unified "Our Services" page */}
          <Route path="service" element={<ServicePage />} />
          <Route path="solutions" element={<WhatWeDo />} />
          <Route path="service-single/:slug" element={<ServiceSinglePage />} />
          <Route path="terms-conditions" element={<TermsPage />} />
          <Route path="privacy-policy" element={<PrivacyPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="serve" element={<WhoWeServe />} />
          <Route path="federal-civilian" element={<Federal />} />
          <Route path="department" element={<Department />} />
          <Route path="sled" element={<Sled />} />
          <Route path="commercial" element={<Commercial />} />
          <Route path="health-care" element={<Health />} />
          {/* Consolidated into /service; redirect keeps existing /offer links working. */}
          <Route path="offer" element={<Navigate to="/service" replace />} />
          <Route path="it-modernization" element={<ItModernization />} />
          <Route path="workforce" element={<Workforce />} />
          <Route path="digital" element={<DigitalTransformation />} />
          <Route path="cybersecurity" element={<Cybr />} />
          <Route path="ai-automation" element={<AiAutomation />} />
          <Route path="army" element={<ArmySolutions />} />
          <Route path="air-force" element={<AirForce />} />
          <Route path="space-force" element={<SpaceForce />} />
          <Route path="navy" element={<NavySolutions />} />
          <Route path="marine-corps" element={<MarineCorps />} />
          <Route path="partners" element={<ViewPartners />} />
          <Route path="view-partners" element={<ViewPartners />} />
          <Route path="contracts" element={<ModernContractsPage />} />
          <Route path="nasa-sewp-vi" element={<NasaSewpPage />} />
          <Route path="accessories" element={<AccessoriesCatalog />} />
          <Route path="cart" element={<CartPage />} />
          <Route path="checkout" element={<CheckoutPage />} />
          <Route path="product/:productId" element={<ProductPage />} />
        </Routes>
        </CartProvider>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
